// Utils
import { toIntegerFromString } from './toIntegerFromString';
import { toIntegerFromBool } from './toIntegerFromBool';
import { isNanOrNull } from './isNanOrNull';
export var toInteger = function (value) {
    if (isNanOrNull(value)) {
        return 0;
    }
    var valueType = typeof value;
    switch (valueType) {
        case ('number'):
            return Number.parseInt(value, 10);
        case ('string'):
            return toIntegerFromString(value);
        case 'boolean':
            return toIntegerFromBool(value);
        case 'object':
            throw new Error("Can't convert an object to an int!");
        default:
            console.error("Unknown type to process: " + valueType);
    }
    return 0;
};
//# sourceMappingURL=toInteger.js.map